var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 14a2 2 0 11-.001-3.999A2 2 0 0112 14zm7 0a2 2 0 11-.001-3.999A2 2 0 0119 14zM5 14a2 2 0 11-.001-3.999A2 2 0 015 14z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8Zz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCAwSDI0VjI0SDB6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTgwIC0xMDApIHRyYW5zbGF0ZSgtMSA3MCkgdHJhbnNsYXRlKDE4MSAzMCkiLz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0xMiAxNGMtMS4xMDUgMC0yLS44OTUtMi0ycy44OTUtMiAyLTIgMiAuODk1IDIgMi0uODk1IDItMiAyem03IDBjLTEuMTA1IDAtMi0uODk1LTItMnMuODk1LTIgMi0yIDIgLjg5NSAyIDItLjg5NSAyLTIgMnpNNSAxNGMtMS4xMDUgMC0yLS44OTUtMi0ycy44OTUtMiAyLTIgMiAuODk1IDIgMi0uODk1IDItMiAyeiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE4MCAtMTAwKSB0cmFuc2xhdGUoLTEgNzApIHRyYW5zbGF0ZSgxODEgMzApIi8+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgIconsMore as ReactComponent };